import ChangeCamelToSnakeCase from "@/app/infrastructures/misc/common-library/ChangeCamelToSnakeCase";

interface MyObject {
  [key: string]: any;
}
const ConvertObjectCamelToSnakeCase = (obj: any): any => {
  const newObj: MyObject = {};
  for (const [key, value] of Object.entries(obj)) {
    const isFile = value instanceof (File || Blob);
    const isObject = typeof value === "object" && value;

    if (Array.isArray(value)) {
      newObj[ChangeCamelToSnakeCase(key)] = value.map((v) =>
        typeof v === "object" ? ConvertObjectCamelToSnakeCase(v) : v
      );
    } else if (isObject && !isFile) {
      newObj[ChangeCamelToSnakeCase(key)] = ConvertObjectCamelToSnakeCase(
        value
      );
    } else {
      newObj[ChangeCamelToSnakeCase(key)] = value;
    }
  }
  return newObj;
};

export const ConvertObjectCamelToSnakeCaseV2 = (data: any): any => {
  const handleValue = (value: any): any => {
    if (!value || typeof value !== "object") return value;
    if (value instanceof File || value instanceof Blob) return value;
    if (Array.isArray(value)) return value.map(handleValue);
    return ConvertObjectCamelToSnakeCaseV2(value);
  };

  // 👉 jika input adalah array, proses tiap item dan return array
  if (Array.isArray(data)) {
    return data.map(handleValue);
  }

  // 👉 jika input adalah object biasa, ubah key-nya ke snake_case
  const newObj: Record<string, any> = {};
  for (const [key, value] of Object.entries(data)) {
    newObj[ChangeCamelToSnakeCase(key)] = handleValue(value);
  }

  return newObj;
};

// remove falsy value
export const ConvertObjectCamelToSnakeCaseV3 = (data: any): any => {
  const transform = (val: any): any => {
    if (val instanceof File || val instanceof Blob) return val;

    if (Array.isArray(val)) {
      const cleaned = val.map(transform).filter(Boolean);
      return cleaned.length ? cleaned : undefined;
    }

    if (val && typeof val === "object") {
      const cleaned = Object.fromEntries(
        Object.entries(val)
          .map(([k, v]) => [ChangeCamelToSnakeCase(k), transform(v)])
          .filter(([, v]) => Boolean(v))
      );

      return Object.keys(cleaned).length ? cleaned : undefined;
    }

    return val;
  };

  return transform(data);
};

export default ConvertObjectCamelToSnakeCase;
